import React, { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import martinBregant from '../assets/Martin_Bregant.jpeg';
import mojcaMusic from '../assets/Mojca_Music.png';
import masaRozman from '../assets/masa.png';

const MARTIN_FALLBACK = {
  role: 'Martin Bregant, odvetnik, mediator in direktor',
  paragraphs: [
    'Martin Bregant je leta 2025 obeležil 30 let samostojnega opravljanja odvetniškega poklica. Svojo poklicno pot je začel kot sodnik na Okrajnem sodišču v Ljubljani ter kasneje še na Okrajnem sodišču v Kamniku. Leta 1995 je sodniško kariero zaključil in svojo strokovno pot nadaljeval kot odvetnik.',
    'Svojim strankam nudi premišljeno, strateško in odgovorno pravno zastopanje. Izhaja iz temeljite pravne presoje primera, ob upoštevanju sodne prakse, dokaznih možnosti in realnih procesnih tveganj. Zaradi dolgoletnih izkušenj v sodstvu in odvetništvu zna oceniti zadevo tudi z vidika odločanja sodišča, kar omogoča premišljeno načrtovanje strategije.',
    'Zaveda se, da pravni postopki za posameznika predstavljajo pomembno življenjsko prelomnico, zato si prizadeva za strokovno, a hkrati človeško obravnavo vsake zadeve.',
    'Poleg odvetniškega dela deluje tudi kot mediator. Stranke ga lahko najamejo za vodenje mediacijskih postopkov, kadar želijo spor rešiti mirno, hitro in z dogovorom, ki upošteva interese vseh udeleženih. Njegove izkušnje iz sodstva in odvetništva mu omogočajo nepristransko in učinkovito vodenje mediacijskega procesa.',
    'Stranke sprejema po predhodnem dogovoru.',
  ],
  contactTitle: 'Kontakt:',
  emailLabel: 'e-pošta:',
  phoneLabel: 'Telefon:',
  email: 'martin.bregant@siol.net',
  phone: '040-811-830',
};

export default function AboutUs() {
  const { t } = useLanguage();
  const [openSections, setOpenSections] = useState({ mojca: false });
  const martinContent = t.aboutUs?.martin || MARTIN_FALLBACK;
  const mojcaContent = t.aboutUs?.mojca;
  const thirdContent = t.aboutUs?.third;

  const sectionLabel = t.aboutUs?.sectionLabel || t.aboutUs?.title || 'O nas';
  const mainTitle = t.aboutUs?.mainTitle || t.aboutUs?.title || 'O nas';
  const teamLabel = t.aboutUs?.teamLabel || 'Ekipa';
  const teamTitle = t.aboutUs?.teamTitle || 'Sodelavci pisarne';
  const achievementsToggle = t.aboutUs?.achievementsToggle || 'Dosežki in publikacije';
  const martinHighlightItems = Array.isArray(t.aboutUs?.martinHighlights) ? t.aboutUs.martinHighlights : [];
  const martinParagraphs = Array.isArray(martinContent?.paragraphs) ? martinContent.paragraphs : [];
  const mojcaParagraphs = Array.isArray(mojcaContent?.paragraphs) ? mojcaContent.paragraphs : [];
  const thirdParagraphs = Array.isArray(thirdContent?.paragraphs) ? thirdContent.paragraphs : [];
  const mojcaTags = Array.isArray(t.aboutUs?.mojcaTags) ? t.aboutUs.mojcaTags : [];
  const thirdTags = Array.isArray(t.aboutUs?.thirdTags) ? t.aboutUs.thirdTags : [];
  const yearsExperienceValue = t.aboutUs?.yearsExperienceValue || '30+';
  const yearsExperienceLabel = t.aboutUs?.yearsExperienceLabel || 'let izkušenj';

  const toggleSection = (sectionKey) => {
    setOpenSections((prev) => ({ ...prev, [sectionKey]: !prev[sectionKey] }));
  };

  return (
    <div className="about-us-page">
      <section className="aboutus-page-header">
        <div className="aboutus-page-label">{sectionLabel}</div>
        <h1>{mainTitle}</h1>
        <p>{t.aboutUs.intro}</p>
      </section>

      <section className="aboutus-founder">
        <div className="aboutus-founder-grid">
          <div className="aboutus-founder-photo">
            <div className="aboutus-founder-photo-frame">
              <img src={martinBregant} alt="Martin Bregant" />
            </div>
            <div className="aboutus-founder-photo-accent">
              <div className="val">{yearsExperienceValue}</div>
              <div className="lbl">{yearsExperienceLabel}</div>
            </div>
          </div>

          <div className="aboutus-founder-content">
            <h2 className="aboutus-founder-name">Martin Bregant</h2>
            <div className="aboutus-founder-role">{martinContent?.role || ''}</div>

            <div className="aboutus-founder-bio">
              {martinParagraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>

            {martinHighlightItems.length > 0 && (
              <div className="aboutus-founder-highlights">
                {martinHighlightItems.map((item) => (
                  <div className="aboutus-highlight-item" key={item.title}>
                    <div className="aboutus-highlight-icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <circle cx="12" cy="12" r="10" />
                        <path d="M12 8v4l3 2" />
                      </svg>
                    </div>
                    <div className="aboutus-highlight-text">
                      <strong>{item.title}</strong>
                      {item.text}
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="aboutus-founder-contact">
              {martinContent?.email && (
                <a href={`mailto:${martinContent.email}`} className="aboutus-contact-chip">
                  {martinContent.email}
                </a>
              )}
              {martinContent?.phone && (
                <a href={`tel:${String(martinContent.phone).replace(/[^+\d]/g, '')}`} className="aboutus-contact-chip">
                  {martinContent.phone}
                </a>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="aboutus-team-section">
        <div className="aboutus-team-section-header">
          <div className="aboutus-page-label">{teamLabel}</div>
          <h2>{teamTitle}</h2>
        </div>

        <div className="aboutus-team-grid">
          {mojcaContent && (
            <article className="aboutus-team-card">
              <div className="aboutus-team-card-photo">
                <img src={mojcaMusic} alt="Mojca Musič" />
              </div>
              <div className="aboutus-team-card-body">
                <h3 className="aboutus-team-card-name">Mojca Musič</h3>
                <div className="aboutus-team-card-role">{mojcaContent.role}</div>
                <div className="aboutus-team-card-bio">
                  {mojcaParagraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>

                {mojcaTags.length > 0 && (
                  <div className="aboutus-team-card-tags">
                    {mojcaTags.map((tag) => (
                      <span className="aboutus-tag" key={tag}>{tag}</span>
                    ))}
                  </div>
                )}

                {Array.isArray(mojcaContent.achievements) && mojcaContent.achievements.length > 0 && (
                  <>
                    <button
                      type="button"
                      className={`aboutus-achievements-toggle ${openSections.mojca ? 'open' : ''}`}
                      onClick={() => toggleSection('mojca')}
                    >
                      {achievementsToggle}
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="m6 9 6 6 6-6" />
                      </svg>
                    </button>

                    <div className={`aboutus-achievements-content ${openSections.mojca ? 'open' : ''}`}>
                      <div className="aboutus-achievements-list">
                        {mojcaContent.achievements.map((item) => (
                          <div className="aboutus-achievement-item" key={item}>{item}</div>
                        ))}
                      </div>

                      {Array.isArray(mojcaContent.bibliography) && mojcaContent.bibliography.length > 0 && (
                        <div className="aboutus-publications-list">
                          {mojcaContent.bibliography.map((item) => (
                            <div className="aboutus-pub-item" key={item}>{item}</div>
                          ))}
                        </div>
                      )}
                    </div>
                  </>
                )}

                <div className="aboutus-team-card-contact">
                  {mojcaContent.email && <a href={`mailto:${mojcaContent.email}`}>{mojcaContent.email}</a>}
                  {mojcaContent.phone && (
                    <a href={`tel:${String(mojcaContent.phone).replace(/[^+\d]/g, '')}`}>{mojcaContent.phone}</a>
                  )}
                </div>
              </div>
            </article>
          )}

          {thirdContent && (
            <article className="aboutus-team-card">
              <div className="aboutus-team-card-photo">
                <img src={masaRozman} alt="Maša Rožman" />
              </div>
              <div className="aboutus-team-card-body">
                <h3 className="aboutus-team-card-name">Maša Rožman</h3>
                <div className="aboutus-team-card-role">{thirdContent.role}</div>
                <div className="aboutus-team-card-bio">
                  {thirdParagraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>

                {thirdTags.length > 0 && (
                  <div className="aboutus-team-card-tags">
                    {thirdTags.map((tag) => (
                      <span className="aboutus-tag" key={tag}>{tag}</span>
                    ))}
                  </div>
                )}

                <div className="aboutus-team-card-contact">
                  {thirdContent.email && <a href={`mailto:${thirdContent.email}`}>{thirdContent.email}</a>}
                  {thirdContent.phone && (
                    <a href={`tel:${String(thirdContent.phone).replace(/[^+\d]/g, '')}`}>{thirdContent.phone}</a>
                  )}
                </div>
              </div>
            </article>
          )}
        </div>
      </section>
    </div>
  );
}
